module.exports = __webpack_public_path__ + "static/media/Kick808_1.e9505dc8.wav";